import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from 'store'
import getSystemLanguage from 'utils/getSystemLanguage'
import enMessage from './en-us'
import cnMessage from './zh-cn'

Vue.use(VueI18n)

const storeLanguage = store.state.settings.language
const locale = storeLanguage || getSystemLanguage()
const modules = {
  'en-us': enMessage,
  'zh-cn': cnMessage
}
const i18n = new VueI18n({
  messages: modules,
  locale
})

export default i18n
